export default {
	"lang": "en",
	"page-title": "Phân Tích Thị Trường",
}